<template>
    <div>
        <va-row :gutter="12">
            <va-column
                v-if="user && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor') || user.get('roles').includes(section + '-apporver') || user.get('roles').includes(section + '-creator'))"
                :lg="12" :md="12" :sm="12" :xs="12" style="position:relative">
                <div style="padding-right: 10px; ">
                    <p class="field_label" style="margin-bottom:10px;">{{ _(title)}}</p>

                    <my-typeahead v-if="!disable" :name="Date.now().toString()" v-model="usernameOrEmail" :limit="10"
                        :debounce="100" :show-clean="isAssigning" :disabled="!isAssigning && showRequired"
                        :placeholder="_('Name or username')" @change="getUsers" :items="getSearchedUsers"
                        :item-render="g_userRenderer" :add-format="selectedUser" :dropdownWidth="'400px'">
                    </my-typeahead>

                </div>
                <div v-if="showRequired && !disable" style="position: absolute; top:14px; right:4px;">
                    <va-checkbox v-model="isAssigning">{{ _('Require Approval')
                        }}</va-checkbox>
                </div>
            </va-column>
            <p v-else class="field_label" style="margin-bottom:10px;">{{ _(title)}}</p>

        </va-row>

        <va-row :gutter="12">
            <va-column :lg="12" :md="12" :sm="12" :xs="12">
                <div v-for="(theUser, index) in selectedUsers" v-if="selectedUsers.length !== 0"
                    style="margin-bottom: 5px">
                    <va-card style="position: relative;" :elevation="0" padding="10">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div style="display: flex; justify-content: left">
                                <img v-if="theUser && theUser.user && theUser.user.get('profilePic')" width="45px"
                                    height="45px" style="margin: 5px 10px 5px 10px; border-radius: 100px;"
                                    :src="theUser.user.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')">
                                <img v-else width="45px" height="45px"
                                    style="margin: 5px 10px 0 10px; border-radius: 100px;"
                                    src="@/assets/emptyProfile.jpg">

                                <div>
                                    <span
                                        style="position: absolute; top: 10%; max-width: 65%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{theUser.user.get('name') }}</span>
                                    <span
                                        style="position: absolute; top: 45%; color: gray; max-width: 65%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{theUser.user.get('username')}}</span>
                                    <span v-if="user.hasSubmission" style="position: absolute; top: 70%; color: green">
                                        {{ _('has submission') }}</span>
                                </div>
                            </div>
                            <va-button
                                v-if="!disable && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor'))"
                                @click.native="deleteUser(index)"
                                style="margin-top: 7px; margin-right: 5px; float: right;">
                                <va-icon type="times"></va-icon>
                            </va-button>
                        </div>
                    </va-card>
                </div>
            </va-column>
        </va-row>
    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import MyTypeahead from '@/components/MyTypeahead.vue';

    export default {

        props: ['showRequired', 'title', 'selected', 'isAssigningUser', 'roles', 'disable', 'department'],

        components: {
            MyTypeahead,
        },

        data() {
            return {
                selectedUsers: [],
                usernameOrEmail: '',
                isAssigning: false,
                getSearchedUsers: [],
                section: ''
            }
        },

        computed: {
            ...mapGetters(['user']),
        },

        watch: {
            isAssigning: function (val) {
                if (!val) this.selectedUsers = []
                this.$emit('update:isAssigningUser', val)
            },

            selectedUsers(val) {
                this.$emit('update:selected', val)
            },

            selected(val) {
                this.selectedUsers = this.selected
            },

            isAssigningUser(val) {
                this.isAssigning = val
            }
        },

        methods: {
            ...mapActions(['fetchUsers']),

            async getUsers(query) {
                this.getSearchedUsers = await this.fetchUsers({ query, roles: this.roles, department: this.department })
            },

            selectedUser(user) {
                this.usernameOrEmail = ''
                if (this.selectedUsers.length !== 0) {
                    var result = []

                    this.selectedUsers.forEach(theUser => {
                        if (user.get('username') == theUser.user.get('username')) result.push(true)
                        else result.push(false)
                    })
                    if (!result.includes(true)) this.selectedUsers.unshift({ user: user, isPrev: false, hasSubmission: false })
                    return true
                } else {
                    this.selectedUsers.unshift({ user: user, isPrev: false, hasSubmission: false })
                }
            },

            deleteUser(index) {
                this.selectedUsers.splice(index, 1);
            },
        },

        mounted() {
            this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
        },

    }
</script>